import React from "react"
import { Box, Chip, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material"

export default function AssignedApplicationsTable({ applications = [] }) {
  return (
    <Paper component="section" aria-label="Assigned applications" variant="outlined" sx={{ borderRadius: 3, borderColor: "#dce7e7", overflow: "hidden", minWidth: 0 }}>
      <Stack direction="row" alignItems="center" spacing={1} sx={{ px: 2.5, py: 1.75 }}>
        <Typography component="h3" variant="subtitle1" fontWeight={600}>Assigned applications</Typography>
        <Chip size="small" label={applications.length} sx={{ bgcolor: "#eaf3f3", color: "#225c60", fontWeight: 600 }} />
      </Stack>
      {!applications.length ? (
        <Typography variant="body2" color="text.secondary" sx={{ px: 2.5, pb: 2.5 }}>No applications assigned.</Typography>
      ) : (
        <TableContainer tabIndex={0} role="region" aria-label="Assigned applications table, scroll horizontally on smaller screens"
          sx={{ "&:focus-visible": { outline: "2px solid #116c6f", outlineOffset: -2 } }}>
          <Table size="small" aria-label="Assigned applications" sx={{
            minWidth: 760, tableLayout: "fixed",
            "& th": { bgcolor: "#f5f8fa", color: "#566874", fontSize: 12, fontWeight: 600, py: 1.25 },
            "& td": { py: 1.75, verticalAlign: "top", borderColor: "#edf1f3", overflowWrap: "anywhere" },
            "& tr:last-child td": { borderBottom: 0 },
          }}>
            <TableHead>
              <TableRow>
                <TableCell sx={{ width: "38%" }}>Application</TableCell>
                <TableCell sx={{ width: "22%" }}>Version</TableCell>
                <TableCell sx={{ width: "11%" }}>Version code</TableCell>
                <TableCell align="right" sx={{ width: "11%" }}>Installs</TableCell>
                <TableCell sx={{ width: "18%" }}>Assigned at</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {applications.map((app, index) => (
                <TableRow hover key={`${app.applicationId ?? app.appId}-${index}`}>
                  <TableCell><Typography variant="body2" fontWeight={600}>{app.appName || "Unnamed application"}</Typography></TableCell>
                  <TableCell>{app.appVersion ?? "Not reported"}</TableCell>
                  <TableCell><Box component="span" sx={{ fontVariantNumeric: "tabular-nums" }}>{app.versionCode ?? "Not reported"}</Box></TableCell>
                  <TableCell align="right" sx={{ fontVariantNumeric: "tabular-nums", fontWeight: 600, color: "#225c60" }}>{app.totInstallCount ?? "Not reported"}</TableCell>
                  <TableCell sx={{ fontSize: 12 }}>{app.assignedAt ?? "Not reported"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Paper>
  )
}
